import FeatureItem from './FeatureItem';

export default FeatureItem;
